import { render, staticRenderFns } from "./bindRecordDrawer.vue?vue&type=template&id=6e9206eb&scoped=true"
import script from "./bindRecordDrawer.vue?vue&type=script&lang=js"
export * from "./bindRecordDrawer.vue?vue&type=script&lang=js"
import style0 from "./bindRecordDrawer.vue?vue&type=style&index=0&id=6e9206eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9206eb",
  null
  
)

export default component.exports